// extracted by mini-css-extract-plugin
module.exports = {"figure":"responsive-image_figure__BJE82","figure--background":"responsive-image_figure--background__ggSae","wrapper":"responsive-image_wrapper___0sLV"};